"use client";
import React from "react";
import Image, { StaticImageData } from "next/image";
import CommonTitle from "../common/CommonTitle";
import CommonSubtitle from "../common/CommonSubtitle";

interface WhyKrooloCard {
  id: number;
  title: string;
  description: string;
  icon: StaticImageData;
}

interface WhyKrooloInfo {
  id: number;
  title: string;
  description: string;
  icon: React.ReactNode;
}

interface WhyKrooloProps {
  whyKrooloInfo: WhyKrooloInfo[];
  whyKroolo: WhyKrooloCard[];
}

const WhyKroolo: React.FC<WhyKrooloProps> = ({ whyKrooloInfo, whyKroolo }) => {
  return (
    <>
      <div className="bg-[#F4F4FD]">
        <div className="container mx-auto px-4 py-8 xl:py-16">
          <div className="mb-8 text-center">
            <CommonTitle
              as="h2"
              fontWeightClass="font-bold"
              color="#202020"
              fontSizeClass="text-[24px] lg:text-[32px] mb-2"
            >
              Why <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">Kroolo?</span>
            </CommonTitle>
          </div>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
            {whyKroolo.map((item) => (
              <div
                key={item.id}
                className="rounded-2xl bg-gradient-to-t to-[#F4F4FD] from-[#ffffff] p-4"
              >
                <div className="mb-4 flex items-center">
                  <Image
                    src={item.icon}
                    alt={item.title}
                    width={32}
                    height={32}
                  />
                </div>
                <CommonTitle
                  as="h3"
                  color="#202020"
                  fontSizeClass="text-[18px] lg:text-[20px] mb-2"
                  fontWeightClass="font-semibold"
                >
                  {item.title}
                </CommonTitle>
                <CommonSubtitle
                >
                  {item.description}
                </CommonSubtitle>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 mt-8">
            {whyKrooloInfo.map((item) => (
              <div
                key={item.id}
                className="rounded-2xl p-4 bg-gradient-to-t to-[#F4F4FD] from-[#ffffff]"
              >
                <div className="flex flex-col justify-center">
                  <div className="mb-4 flex items-center">
                    {item.icon}
                  </div>
                  <CommonTitle
                    as="h3"
                    color="#202020"
                    fontSizeClass="text-[18px] lg:text-[20px] mb-2"
                    fontWeightClass="font-semibold"
                  >
                    {item.title}
                  </CommonTitle>
                  <CommonSubtitle
                  >
                    {item.description}
                  </CommonSubtitle>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyKroolo;
